import { bookService } from './bookService'

/**
 * The book module façade. No store: the publisher's book list and the reviewer's book pages each load
 * what they show, and a book is never shared state between them.
 */
export const useBook = () => {
  return {
    book: {
      service: bookService()
    }
  }
}
